<template>
  <div
    class="flex flex-col py-4 px-6 md:p-4 gap-2 bg-primary border-t border-secondary"
  >
    <Button
      :label="$t('components.buttons.save_changes')"
      size="xl"
      :disabled="!dirty"
      :loading="busy"
      @click.stop="$emit('save')"
    />
    <Button
      v-if="!maxSmall"
      :as="DialogClose"
      :label="$t('components.buttons.cancel')"
      variant="secondary"
      type="gray"
      size="xl"
      @click.stop
    />
  </div>
</template>

<script setup>
import { Button } from "@/SharedComponents/Buttons";
import { DialogClose } from "@/SharedComponents/Dialog";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["save"]);

defineProps({
  dirty: { type: Boolean, required: false },
  busy: { type: Boolean, required: false },
});
</script>
